import { Auth } from '@grammarly/identity-ui'

import { getConfig } from '../../config'
import { getLogger } from '../../lib/tracking/felog/telemetry'

const config = getConfig()

export const authConfig: Auth.Config.Base = {
  cookieDomain: config.domains.cookie,
  accountHub: {
    securityUrl: config.accountHub.security,
  },
  signUpEmailVerificationSupportUrl: config.support.urls.signUpEmailVerification,
  signInEmailFailureSupportUrl: config.support.urls.signInEmailFailure,
  supportNewRequestUrl: config.support.urls.newRequest,
  recaptcha: {
    enterprise: {
      url: config.recaptcha.enterprise.urls.original,
      urlGlobal: config.recaptcha.enterprise.urls.global,
      siteKey: config.recaptcha.enterprise.siteKey,
    },
    visible: {
      url: config.recaptcha.visible.urls.original,
      urlGlobal: config.recaptcha.visible.urls.global,
      siteKey: config.recaptcha.visible.siteKey,
    },
    visibleEnterprise: {
      url: config.recaptcha.visible.urls.original,
      urlGlobal: config.recaptcha.visible.urls.global,
      siteKey: config.recaptcha.visibleEnterprise.sitekey,
    },
  },
  socialOAuth: {
    facebook: {
      clientId: config.socialOAuth.facebook.clientId,
      returnRedirectUrl: '/social/redirect',
    },
    google: {
      clientId: config.socialOAuth.google.clientId,
      returnRedirectUrl: '/social/redirect',
    },
    apple: {
      clientId: config.socialOAuth.apple.clientId,
      returnRedirectUrl: '/api/apple',
    },
  },
}

export const getUnifiedAuthLogger = () => getLogger('identity')
